module.exports = __webpack_public_path__ + "static/media/flora_homepage.6e8ea0ef.jpg";